<template>
  <CardModule class="mt-6" title="Acessos">
    <v-row class="mt-5">
      <v-col cols="12">
        <BaseTextField
          label="URL ElevenTickets Access"
          placeholder="Insira a URL do ElevenTickets Access"
          v-model="$loja_gerenciar.cadastro.acesso.url_circus"
          type="text"
          :rules="isFill ? [rules.required] : []"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Token ElevenTickets Access"
          placeholder="Insira o token do ElevenTickets Access"
          v-model="$loja_gerenciar.cadastro.acesso.token_circus"
          type="text"
          :rules="isFill ? [rules.required] : []"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Evento Padrão"
          placeholder="Insira o evento padrão"
          v-model="$loja_gerenciar.cadastro.acesso.idevento_default"
          type="text"
          @input="$loja_gerenciar.cadastro.acesso.error.idevento_default = []"
          :error-messages="
            $loja_gerenciar.cadastro.acesso.error.idevento_default
          "
        >
        </BaseTextField>
      </v-col>
      <v-row class="px-3 pb-3">
        <v-col cols="12" class="pb-0">
          <v-btn
            class="button rounded-lg"
            width="100%"
            v-if="isEdit && fitToSync"
            @click="syncCircus"
            :loading="$loja_gerenciar.cadastro.acesso.loading_sync"
          >
            Sincronizar
            <v-icon class="ml-2"> mdi-sync </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            class="button rounded-lg"
            width="100%"
            v-if="isEdit && fitToSync"
            @click="syncCircusAll"
          >
            Sincronizar Tudo
            <v-icon class="ml-2"> mdi-sync </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
    <confirm-modal
      v-model="isConfirmationVisible"
      title="Confirmação"
      message="Tem certeza de que deseja realizar a sincronização?"
      subtitle="Importante: ao utilizar essa opção, todos os
              pedidos pagos serão sincronizados novamente. E ação deve ser
              utilizada com cautela, somente como último caso, pois pode levar
              alguns minutos e tambem ocasionar um consumo maior nos servidores."
      @cancel="cancelConfirmation"
      @confirm="confirmAction"
      :loading="$loja_gerenciar.cadastro.acesso.loading_sync_all"
    />
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import mixins from "../../mixins";
import ConfirmModal from "@/components/global/newConfirmDialog.vue";
const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-acessos",
  mixins: [LojasGerenciarMixins, formRules],
  data() {
    return {
      isConfirmationVisible: false,
    };
  },
  components: {
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    ConfirmModal,
  },
  methods: {
    syncCircus() {
      this.$loja_gerenciar.syncCircus(this.$loja_gerenciar.sequenciador);
    },
    syncCircusAll() {
      this.showConfirmation();
    },
    showConfirmation() {
      this.isConfirmationVisible = true;
    },
    cancelConfirmation() {
      this.isConfirmationVisible = false;
    },
    async confirmAction() {
      await this.$loja_gerenciar.syncCircusAll(
        this.$loja_gerenciar.sequenciador
      );
      this.isConfirmationVisible = false;
    },
  },
  computed: {
    isFill() {
      return (
        this.$loja_gerenciar.cadastro.acesso.url_circus !== "" ||
        this.$loja_gerenciar.cadastro.acesso.token_circus !== ""
      );
    },
    isEdit() {
      return this.$loja_gerenciar.lojaAddOrEdit == "edit";
    },
    fitToSync() {
      return this.$loja_gerenciar.cadastro.acesso.circus === 1;
    },
  },
};
</script>
<style scoped>
.lojas-circus-subtitle {
  width: 487px;
  font-size: 1rem;
  align-self: flex-start;
  margin-top: 1.25rem;
}

.lojas-gerenciar-acessos {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
</style>
